export type MessageStatus =
  | "warning"
  | "info"
  | "success"
  | "error"
  | undefined;

export type MessageVariant = "solid" | "subtle" | undefined;

export interface ILink {
  description: string;
  text: string;
  href: string;
}

export interface IMessage {
  status: MessageStatus;
  variant: MessageVariant;
  content: string;
  link: ILink | null;
  bg?: string;
  color?: string;
}

import _messages from "./config/messages.json";
export const messages: Array<IMessage> = _messages as Array<IMessage>;
